module.exports = "<div class=\"item options-input\">\r\n  {{formOption.label}}\r\n  <!--<label class=\"item item-input\">-->\r\n  <!--</label>-->\r\n  <!--TODO(UI): fix styling to be in-line and right-aligned. <popover-select> does not appear to work correctly inside of a <label>-->\r\n  <popover-select\r\n    class=\"form-popover item item-input\"\r\n    ng-model=\"formOption.model[formOption.option]\"\r\n    options=\"option as option for option in formOption.constraints[formOption.option].inList\">\r\n  </popover-select>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/js/forms/directives/options/string-list.html
// module id = 3419
// module chunks = 0